export default __webpack_public_path__ + "static/web_accessibility_mark-aa198e2c5d61478166dd341a80ccbff0.png";